module Navigation {
  let activeNavigationItem: HTMLElement;

  export function construct() {
    var activeLiQuery = $("#sidebarnav li.active");
    if (activeLiQuery.length != 0) {
      activeNavigationItem = activeLiQuery[0];
      activeNavigationItem.scrollIntoView({ block: 'nearest' });
    }
  }
}